import { action } from 'typesafe-actions';

import { KnmErpActionsEnum } from '../enums/KnmErpActionsEnum';
import { IKnmErpForm } from '../interfaces/IKnmErpForm';

export const knmErpSetInitialFormValues = (initialFormValues: IKnmErpForm) =>
  action(KnmErpActionsEnum.KNM_ERP_SET_INITIAL_FORM_VALUES, { initialFormValues });
export const knmErpResetInitialFormValues = () => action(KnmErpActionsEnum.KNM_ERP_RESET_INITIAL_FORM_VALUES);
